/**
 * API responses stringify most scalars; booleans become true/false or "1"/"".
 */
export function isApiTruthy(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value === null || value === undefined) return false;
  const s = String(value).trim().toLowerCase();
  return s === '1' || s === 'true' || s === 'yes';
}

export function parseApiNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
}

/** @param {Record<string, unknown>|null|undefined} restaurant */
export function normalizeRestaurantApiFields(restaurant) {
  if (!restaurant || typeof restaurant !== 'object') return restaurant;

  return {
    ...restaurant,
    can_order: isApiTruthy(restaurant.can_order),
    is_nearby: isApiTruthy(restaurant.is_nearby),
    is_open: isApiTruthy(restaurant.is_open),
    on_holiday: isApiTruthy(restaurant.on_holiday),
    is_restaurant_of_the_day: isApiTruthy(restaurant.is_restaurant_of_the_day),
    distance_km: parseApiNumber(restaurant.distance_km),
  };
}

export function formatDistanceMilesFromKm(distanceKm) {
  const km = parseApiNumber(distanceKm);
  if (km === null) return null;
  const miles = km * 0.621371;
  if (miles < 0.1) return 'Less than 0.1 mi from you';
  return `${miles.toFixed(1)} mi from you`;
}
